//jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\NewsAddScreen.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import { useCreateNewsMutation } from '../../slices/newsApiSlice';
import { useGetAllAuthorsQuery } from '../../slices/authorsApiSlice';
import { useGetBookListQuery } from '../../slices/booksApiSlice';

const NewsAddScreen = () => {

  const navigate = useNavigate();
    
  const [title, setTitle] = useState('');
  const [image, setImage] = useState('');
  const [description, setDescription] = useState('');
  const [event, setEvent] = useState('');
  const [linkRelated, setLinkRelated] = useState('');
  const [authorsRelated, setAuthorsRelated] = useState([]);
  const [bookRelated, setBookRelated] = useState([]);
  const [isVisible, setIsVisible] = useState(true);

  // Récupération des listes des auteurs et livres
  const [searchAuthorTerm, setSearchAuthorTerm] = useState('');
  const [searchBookTerm, setSearchBookTerm] = useState('');
  
  const { data: authors, isLoading: loadingAuthors } = useGetAllAuthorsQuery({
    keyword: searchAuthorTerm,
  });
  const authorsList = authors?.authors || [];

  const { data: books, isLoading: loadingBooks } = useGetBookListQuery({
    keyword: searchBookTerm,
    adminSpace:'true',
  });
  const bookList = books?.books || [];

  const [createNews, { isLoading }] = useCreateNewsMutation();

  const submitHandler = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('event', event);
    formData.append('authorsRelated', JSON.stringify(authorsRelated)); // Les tableaux doivent être convertis en JSON
    formData.append('bookRelated', JSON.stringify(bookRelated));
    formData.append('linkRelated', linkRelated);
    formData.append('isVisible', isVisible);
    
    // Ajouter l'image si elle existe
    if (image instanceof FormData) {
      formData.append('image', image.get('image'));
    }

    // Inspecter le contenu du FormData
    console.log('FormData contenu :');
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value, '!!');
    }

    try {
      await createNews(formData).unwrap();
      toast.success('Actu ajoutée avec succès');
      navigate('/admin/newslist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }

  }

  return (
    <Container>
      <FormContainer>
        <div className="h1-adminContainer">
          <h1>Ajouter une actualité</h1>
        </div>
        {isLoading && <Loader />}
        <Form onSubmit={submitHandler}>
          <Form.Group controlId='title'>
            <Form.Label>Titre*</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir le titre'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId='event'>
            <Form.Label>Dates et lieu</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir les dates et lieu'
              value={event}
              onChange={(e) => setEvent(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId='image'>
            <Form.Label>Illustration</Form.Label>
            <Form.Control
              type='file'
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const formData = new FormData();
                  formData.append('image', file);
                  setImage(formData);
                }
              }}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='description'>
            <Form.Label>Texte*</Form.Label>
            <ReactQuill value={description} onChange={setDescription} />
          </Form.Group>

          <Form.Group controlId='linkRelated'>
            <Form.Label>Ajouter un lien</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir le titre'
              value={linkRelated}
              onChange={(e) => setLinkRelated(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId='authorsRelated'>
            <Form.Label>Associer des auteurs à cette actualité</Form.Label>
              <Form.Control
                type="text"
                placeholder="Chercher un auteur..."
                value={searchAuthorTerm}
                onChange={(e) => setSearchAuthorTerm(e.target.value)}
              />
            {loadingAuthors ? (
              <Loader />
            ) : (
                  <div className="checkboxList"  style={{ maxHeight: '137px', overflowY: 'auto' }}>
                    {Array.from(
                        new Set([
                          ...authorsList.filter((author) => authorsRelated.includes(author._id)), // Ajoute les livres déjà cochés
                          ...authorsList.filter((author) => author.lastName.toLowerCase().includes(searchAuthorTerm.toLowerCase())
                          ),
                        ])
                      ).map((author) => (
                      <div key={author._id} style={{ marginBottom: '5px' }}>
                        <label style={{ fontWeight: authorsRelated.includes(author._id) ? 'bold' : 'normal', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            value={author._id}
                            checked={authorsRelated.includes(author._id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setAuthorsRelated((prevAuthors) => [...prevAuthors, author._id]);
                              } else {
                                setAuthorsRelated((prevAuthors) => prevAuthors.filter((id) => id !== author._id));
                              }
                            }}
                            style={{ marginRight: '5px' }}
                          />
                          {author.firstName} {author.lastName}
                        </label>
                      </div>
                    ))}
                  </div>
            )}
          </Form.Group>
          <Form.Group controlId='bookRelated'>
          <Form.Label>Associer des livres à cette actualité</Form.Label>

          {/* Champ de recherche */}
          <Form.Control
            type="text"
            placeholder="Chercher un livre..."
            value={searchBookTerm}
            onChange={(e) => setSearchBookTerm(e.target.value)}
          />

          {/* Liste filtrée des livres */}
          {loadingBooks ? (
            <Loader />
          ) : (
            <div style={{ maxHeight: '137px', overflowY: 'auto', border: '1px solid #ccc', padding: '5px' }}>
              {Array.from(
                new Set([
                  ...bookList.filter((book) => bookRelated.includes(book._id)), // Ajoute les livres déjà cochés
                  ...bookList.filter((book) => book.title.toLowerCase().includes(searchBookTerm.toLowerCase())
                  ),
                ])
              ).map((book) => (
                <div key={book._id} style={{ marginBottom: '5px' }}>
                  <label style={{ fontWeight: bookRelated.includes(book._id) ? 'bold' : 'normal', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      value={book._id}
                      checked={bookRelated.includes(book._id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setBookRelated((prevBooks) => [...prevBooks, book._id]);
                        } else {
                          setBookRelated((prevBooks) => prevBooks.filter((id) => id !== book._id));
                        }
                      }}
                      style={{ marginRight: '5px' }}
                    />
                    {book.title}
                  </label>
                </div>
              ))}
            </div>
          )}
        </Form.Group>

          {/* <Form.Group controlId='bookRelated'>
          <Form.Label>Associer des livres à cette actualité</Form.Label>
          {loadingBooks ? (
            <Loader />
          ) : (
            <div style={{ maxHeight: '107px', overflowY: 'auto', border: '1px solid #ccc', padding: '5px' }}>
              {bookList.map((book) => (
                <div key={book._id} style={{ marginBottom: '5px' }}>
                  <label style={{ fontWeight: bookRelated.includes(book._id) ? 'bold' : 'normal', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      value={book._id}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setBookRelated((prevBooks) => [...prevBooks, book._id]);
                        } else {
                          setBookRelated((prevBooks) => prevBooks.filter((id) => id !== book._id));
                        }
                      }}
                      style={{ marginRight: '5px' }}
                    />
                    {book.title}
                  </label>
                </div>
              ))}
            </div>
          )}
        </Form.Group> */}

          {/* <Form.Group controlId="bookRelated" className="deuxchamps">
            <Form.Control
              type="text"
              placeholder="Saisir un terme..."
              value={searchBookTerm}
              onChange={(e) => setSearchBookTerm(e.target.value)}
            />
            {loadingBooks ? (
              <Loader />
            ) : (
              <Form.Control
                as="select"
                value={bookRelated}
                onChange={(e) => setBookRelated(e.target.value)}
              >
                <option value="">Sélectionner un livre</option>
                {bookList?.map((book) => (
                  <option key={book._id} value={book._id}>
                    {book.title}
                  </option>
                ))}
              </Form.Control>
            )}
          </Form.Group> */}

          <Form.Group controlId='isVisible'>
            <Form.Check
              type='checkbox'
              label='Visible'
              checked={isVisible}
              onChange={(e) => setIsVisible(e.target.checked)}
            />
          </Form.Group>

          <Button type='submit' variant='primary' className='mt-3'>Ajouter</Button>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default NewsAddScreen;
